/* What the "Payment received" page can tell from the candidate's own ledger.

   Stripe sends the student back the moment they pay; the entries are granted by
   the webhook, usually seconds later. The ledger row names the payment by its own
   id, not by the Stripe session in the URL, so "this payment has arrived" is read
   as: a payment grant dated no earlier than a few minutes before the page opened,
   or the balance rising while the page watches. An enrol-now purchase grants and
   spends in the same step, so its balance never moves — the grant is what counts. */

export const ARRIVAL_WAIT_MS = 2 * 60 * 1000;
export const GRANT_LOOKBACK_MS = 10 * 60 * 1000;
export const REFERENCE_LENGTH = 8;

export const shortReference = (sessionId) =>
    (sessionId || '').trim().slice(-REFERENCE_LENGTH);

const timeOf = (txn) => {
    const at = Date.parse(txn?.created_at || '');
    return Number.isNaN(at) ? null : at;
};

/* 'enrolled' when the newest recent payment grant was spent on an enrolment,
   'credited' when entries arrived and stayed, null while nothing has arrived. */
export const checkoutOutcome = ({ firstBalance, entries, openedAt }) => {
    const balance = entries?.entries_balance ?? null;
    const transactions = Array.isArray(entries?.transactions) ? entries.transactions : [];

    const grants = transactions
        .filter((txn) => txn?.type === 'grant' && txn?.source_type === 'payment')
        .map((txn) => ({ txn, at: timeOf(txn) }))
        .filter(({ at }) => at !== null && at >= openedAt - GRANT_LOOKBACK_MS)
        .sort((a, b) => b.at - a.at);

    if (grants.length > 0) {
        const grantedAt = grants[0].at;
        const spentOnEnrolment = transactions.some((txn) => {
            const at = timeOf(txn);
            return txn?.type === 'spend' && txn?.source_type === 'enrolment' && at !== null && at >= grantedAt;
        });
        return spentOnEnrolment ? 'enrolled' : 'credited';
    }

    if (firstBalance !== null && balance !== null && balance > firstBalance) return 'credited';
    return null;
};
